import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PlusCircle } from "lucide-react";
import { CareShell } from "@/components/CareShell";
import { SpecialistProfileBody } from "@/components/CareSpecialist";
import api from "@/lib/api";

export default function SpecialistDetail() {
  const { specialistId } = useParams();
  const navigate = useNavigate();
  const [sp, setSp] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/care/specialists/${specialistId}`)
      .then(({ data }) => setSp(data))
      .catch(() => setSp(null))
      .finally(() => setLoading(false));
  }, [specialistId]);

  return (
    <CareShell active="home" title="Specialist" showBack onBack={() => navigate(-1)}>
      {loading ? (
        <div className="space-y-4">
          <div className="h-24 bg-[#1A1A1A] border border-[#333333] rounded-2xl animate-pulse" />
          <div className="h-48 bg-[#1A1A1A] border border-[#333333] rounded-2xl animate-pulse" />
        </div>
      ) : !sp ? (
        <p className="text-[#A1A1AA]">Specialist not found.</p>
      ) : (
        <>
          <SpecialistProfileBody sp={sp} />
          <button
            data-testid="specialist-request-review-btn"
            onClick={() =>
              navigate(`/care/new?specialty=${encodeURIComponent(sp.specialty)}&specialist=${sp.id}`)
            }
            className="mt-6 w-full rounded-full bg-[#EF9F27] text-[#111111] font-bold px-6 py-3.5 min-h-[48px] flex items-center justify-center gap-2 transition-transform active:scale-[0.97]"
          >
            <PlusCircle size={18} /> Request a review with {sp.name.split(" ").slice(-1)[0]}
          </button>
        </>
      )}
    </CareShell>
  );
}
